/**
 * Clamps a number between a minimum and maximum value.
 */
export function clamp(value: number, min: number, max: number) {
	return Math.max(min, Math.min(max, value));
}
